export enum EventTypes {
  BENEFITS = 'BENEFITS',
  ONBOARDING = 'ONBOARDING',
  RESET_PASSWORD = 'RESET_PASSWORD',
  RESET_PASSWORD_FIXED = 'RESET_PASSWORD_FIXED',
}

export enum EventTypesPt {
  BENEFITS = 'Benefícios',
  ONBOARDING = 'Onboarding',
  RESET_PASSWORD = 'Troca de senha',
  RESET_PASSWORD_FIXED = 'Alteração de senha fixa',
}

export enum Complements {
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum ComplementsPt {
  FAILED = 'Falhou',
  COMPLETED = 'Completo',
  IN_PROGRESS = 'Em progresso',
}

export enum PasswordTypes {
  FIXED = 'FIXED',
  DYNAMIC = 'DYNAMIC',
}

export enum PasswordTypesPt {
  FIXED = 'Senha fixa',
  DYNAMIC = 'Senha token',
}
